import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { FiSetupStatus } from '@core/models';
import { environment, endpoints } from '@environment';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SetupStatusService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/${endpoints.v1.setupStatus}`;

  getStatus(): Observable<FiSetupStatus> {
    return this.http.get<FiSetupStatus>(this.baseUrl);
  }
}
